import { render, staticRenderFns } from "./axsr-landingpage.vue?vue&type=template&id=58526a76&"
import script from "./axsr-landingpage.vue?vue&type=script&lang=js&"
export * from "./axsr-landingpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports